<template>
  <div>
    <Table :searchVisible="false" :key="tableKey" @modalName="showModal" :tableData="dataTable" noNeedToChangeRoute @selectedRow="changeRoute($event)" />
    <b-modal v-model="modalVisible" title="انتخاب" no-close-on-esc hide-footer headerClass="" centered header-close-variant="dark" cancel-title>
      <b-col cols="12">
        <input class="input-style" type="text" :value="selectedName" disabled />
      </b-col>
      <b-col cols="12" class="message-list">
        <ul class="ul-style">
          <li class="p-whiteSpace" style="cursor: pointer" v-for="item in epicData" :key="item.id" @click="selctedItem(item)">
            {{ item.name }}
          </li>
        </ul>
      </b-col>
      <Button @click.native="selectTable" text="انتخاب" btnClass="aprove" />
    </b-modal>
  </div>
</template>

<script>
import Table from '../../common/table/simpleTable/'
import adminDataProvider from '../../../services/superAdmin.js'
import { superAdminMixins } from '../../../utils/mixins'
import Button from '../../common/Button.vue'

export default {
  components: { Table, Button },
  mixins: [superAdminMixins],
  data() {
    return {
      dataTable: [],
      rows: [],
      fields: [],
      tableKey: 0,
      modalVisible: false,
      epicData: null,
      selectedItem: null,
      selectedName: '',
    }
  },
  methods: {
    changeRoute(payload) {
      let boardId = Number(payload.items.find((item) => item.fieldName === 'BoardId').value)
      let tableId = Number(payload.items.find((item) => item.fieldName === 'TableId').value)
      let teamtaskName = payload.items.find((item) => item.fieldName === 'Key').value
      this.setInitialData({ tableId: tableId, boardId: boardId, teamtaskName: teamtaskName }).then(() => {
        this.$router.push(`/superadmin/general?teamtaskName=${teamtaskName}&tableId=${tableId}&boardId=${boardId}`)
      })
      console.log('boardId: ', boardId, ' tableId: ', tableId)
      // this.getTeamtaskData({tableId:tableId,boardId:boardId})
    },
    getTeamtaskData(payload) {
      adminDataProvider.getTeamtaskData(payload)
    },
    getData(payload) {
      adminDataProvider
        .getAllTeamtasks(payload)
        .then((res) => {
          this.dataTable = res.data
        })
        .then(() => {
          this.tableKey += 1
        })
    },
    showModal() {
      adminDataProvider.getEpicList().then((res) => {
        this.epicData = res.data.data.epicName
        setTimeout(() => {
          this.modalVisible = true
        }, 200)
      })
    },
    selctedItem(payload) {
      this.selectedItem = payload.id
      this.selectedName = payload.name
    },
    selectTable() {
      // adminDataProvider.addTable(this.selectedItem).then(()=> {
      //    this.$router.push(`/superadmin/general?teamtaskName=${teamtaskName}&tableId=${tableId}&boardId=${boardId}`)
      // })
    },
  },
  mounted() {
    this.getData({ search: '', pageSize: 10, pageNumber: 1 })
  },
}
</script>

<style scoped>
::-webkit-scrollbar {
  display: none;
}
::v-deep .table-header .actions.d-flex.align-items-end.justify-content-between {
  flex-direction: row-reverse !important;
}
.input-style {
  width: 100%;
  height: 30px;
  border-radius: 5px;
  outline: none;
}
.ul-style {
  height: 170px;
  overflow: auto;
  border: 1px solid #b5b5b5;
  margin-top: 16px;
  padding: 5px;
  border-radius: 5px;
}
.aprove {
  background-color: #556ee6 !important;
  border-radius: 5px !important;
  width: 119px !important;
  margin-right: 4px !important;
}
</style>
